import { render, staticRenderFns } from "./MapClose.vue?vue&type=template&id=beba0262&"
import script from "./MapClose.vue?vue&type=script&lang=ts&"
export * from "./MapClose.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports